import { jsx as _jsx } from "react/jsx-runtime";
import { CanvasItem2D } from '../../../../r3f/components/CanvasItem2D';
import { useSceneResources } from '../../../../r3f/SceneResourcesContext';
import { useSubOrExtResource } from '../../../../resources/useSubOrExtResource';
import { useViewportMode } from '../../../../r3f/contexts/ViewportModeContext';
import { CollisionGizmo2D } from './CollisionGizmo2D';
import { useGodotLinearColor } from '../../../../r3f/godotColor';
import { DEFAULT_COLLISION_DEBUG_COLOR } from '../../shared/debugColor';
export function CollisionShape2D({ node, children }) {
    const properties = node.properties;
    const sceneResources = useSceneResources();
    const { showCollisions } = useViewportMode();
    const shapeResource = useSubOrExtResource(properties.shape, sceneResources)?.resource;
    // Godot draws the shape in the node's own `debug_color`. The literal is sRGB.
    const debugColor = useGodotLinearColor(properties.debugColor ?? DEFAULT_COLLISION_DEBUG_COLOR);
    return (_jsx(CanvasItem2D, { node: node, props: properties, body: () => showCollisions && shapeResource ? _jsx(CollisionGizmo2D, { shape: shapeResource, color: debugColor }) : null, children: children }));
}
//# sourceMappingURL=Component.js.map